import { FLASH_TYPES as TYPES } from '@/consts';

const actions = {
  info({ commit }, msg, autoHide = true) {
    commit('setMessage', msg);
    commit('setType', TYPES.INFO);
    commit('setActiveStatus', { value: true, autoHide });
  },

  error({ commit }, msg, autoHide = true) {
    commit('setMessage', msg);
    commit('setType', TYPES.ERROR);
    commit('setActiveStatus', { value: true, autoHide });
  },

  setActiveStatus({ commit }, val, autoHide = true) {
    commit('setActiveStatus', { val, autoHide });
  }
};

export default actions;
